import React from 'react';

function SelectProjectReceipt() {

    return (
        <div
            id="select-project-receipt-content"
            className="content-block">

            <p className="content-block-text">
                Select a Project Receipt (outer text)
            </p>

            <p className="content-block-text">
                Select a Project Receipt (text inner)
            </p>

            <div
                id="search-container"
                className="search-container">

                <input
                    className="search-input"
                    id="search-input"
                    onClick={() => { console.log('select-project-receipt-search') }}
                    placeholder="&nbsp;&nbsp;search here..."
                />

                <button 
                    className="search-button"
                    id="search-button">
                    button
                </button>
            </div>

        </div>
    )
}

export default SelectProjectReceipt;